module.exports = __webpack_public_path__ + "static/media/logoorange.00142f6c.png";